import React, { Component } from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";

import SetEmailPage from "./components/Account/SetEmailPage";
import SetPasswordPage from "./components/Account/SetPasswordPage";
import ResetPasswordPage from "./components/Account/ResetPasswordPage";
import LoginEmailPage from "./components/EmailLogin/LoginEmailPage";
import ConfirmEmailPage from "./components/Account/ConfirmEmailPage";
import ConfirmUpgradeToVirtualUserPage from "./components/Account/ConfirmUpgradeToVirtualUserPage";
import AccountContainer from "./components/common/AccountContainer";
import LinkExpiredPage from "./components/Account/LinkExpiredPage";

import ProductSelectorPage from "./components/ProductSelector/ProductSelectorPage";
import SiteSetupPage from "./components/SelectorPages/SiteSetupPage";
import SiteSelectorPage from "./components/SelectorPages/SiteSelectorPage";

import SuperUserPage from "./components/SuperUser/SuperUserPage";

import ProductAccessDeniedPage from "./components/ProductAccessDenied/ProductAccessDeniedPage";

import ChangePasswordPage from "./components/User/ChangePasswordPage";
import ExpiredPasswordPage from "./components/User/ExpiredPasswordPage";
import UserLinkingPage from "./components/User/UserLinkingPage";

import PersonnelPage from "./components/Personnel/PersonnelPage";
import Login from "./components/Login/Login";

import SettingsPage from "./components/Settings/SettingsPage";
import UrlHelper from "./utilities/UrlHelper";
import ProfilePage from "newApp/components/Profile/ProfilePage";

export class App extends Component {
    constructor (props, context) {
        super(props, context);
    }

    render () {
        const { store } = this.props;
        // do not analyze query, only path, it's important for security
        const page = UrlHelper.parseUrl().pathname.toLowerCase();

        if (page.indexOf("ssoauth/setemail") >= 0)
            return (<Provider store={store}>
                <AccountContainer>
                    <SetEmailPage isUpgradeToVirtualUser={false}/>
                </AccountContainer>
            </Provider>);

        if (page.indexOf("auth/upgradetovirtualuser") >= 0) {
            return (<Provider store={store}>
                <AccountContainer>
                    <SetEmailPage isUpgradeToVirtualUser={true}/>
                </AccountContainer>
            </Provider>);
        }

        if (page.indexOf("auth/confirmupgradetovirtualuser") >= 0)
            return (<Provider store={store}>
                <AccountContainer>
                    <ConfirmUpgradeToVirtualUserPage />
                </AccountContainer>
            </Provider>);

        if (page.indexOf("ssoauth/confirmemail") >= 0)
            return (<Provider store={store}>
                <AccountContainer>
                    <ConfirmEmailPage />
                </AccountContainer>
            </Provider>);

        if (page.indexOf("auth/emaillogin") >= 0) {
            return (<Provider store={store}>
                <LoginEmailPage />
            </Provider>);
        }

        if (page.indexOf("auth/activateaccount") >= 0) {
            return (<Provider store={store}>
                <AccountContainer>
                    <SetPasswordPage />
                </AccountContainer>
            </Provider>);
        }

        if (page.indexOf("auth/resetemailpassword") >= 0) {
            return (<Provider store={store}>
                <AccountContainer>
                    <ResetPasswordPage />
                </AccountContainer>
            </Provider>);
        }

        if (page.indexOf("auth/linkexpired") >= 0) {
            return (<Provider store={store}>
                <AccountContainer logoClassName="link-expired-logo" hideWKTrademark={true}>
                    <LinkExpiredPage />
                </AccountContainer>
            </Provider>);
        }

        if (page.indexOf("ssoauth/productselector") >= 0) {
            return (<Provider store={store}>
                <ProductSelectorPage/>
            </Provider>);
        }

        if (page.indexOf("auth/superuser") >= 0) {
            return (<Provider store={store}>
                <SuperUserPage/>
            </Provider>);
        }

        if (page.indexOf("auth/productaccessdenied") >= 0) {
            return (<Provider store={store}>
                <ProductAccessDeniedPage/>
            </Provider>
            );
        }

        if (page.indexOf("ssoauth/sitesetup") >= 0) {
            return (<Provider store={store}>
                <SiteSetupPage/>
            </Provider>
            );
        }

        if (page.indexOf("user/changepassword") >= 0) {
            return (<Provider store={store}>
                <ChangePasswordPage/>
            </Provider>
            );
        }

        if (page.indexOf("ssoauth/siteselector") >= 0) {
            return (<Provider store={store}>
                <SiteSelectorPage/>
            </Provider>
            );
        }

        if (page.indexOf("ssoauth/userlinking") >= 0) {
            return (<Provider store={store}>
                <UserLinkingPage/>
            </Provider>
            );
        }

        if (page.indexOf("organizations/personnel") >= 0) {
            const param = page.substr(page.lastIndexOf("/") + 1);
            const organizationId = parseInt(param, 10);
            return (<Provider store={store}>
                <PersonnelPage organizationId={ organizationId }/>
            </Provider>
            );
        }

        if (page.indexOf("organizations/settings") >= 0) {
            const param = page.substr(page.lastIndexOf("/") + 1);
            const organizationId = parseInt(param, 10);
            return (<Provider store={store}>
                <SettingsPage organizationId={ organizationId }/>
            </Provider>
            );
        }

        if (page.indexOf("auth/resetpassword") >= 0) {
            return (<Provider store={store}>
                <ExpiredPasswordPage />
            </Provider>
            );
        }

        if (page.indexOf("auth/login") >= 0) {
            return (<Provider store={store}>
                <Login />
            </Provider>
            );
        }

        if (page.indexOf("auth/userprofile") >= 0) {
            return (<Provider store={store}>
                <ProfilePage/>
            </Provider>
            );
        }


        return null;
    }
}

App.propTypes = {
    store: PropTypes.object.isRequired,
};

export default App;


